import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { connect, ConnectedProps } from 'react-redux';
import { Grid, Button } from 'semantic-ui-react';
import { IState } from '@pvolve/sdk/src/redux/selectors';

import Selectors from 'src/state/root-selectors';

import * as startTrialStyles from 'src/styles/start-trial.module.scss';

const connector = connect((state: IState) => ({
    entitled: Selectors.auth.entitled(state),
}));

const StartTrial = ({ entitled }: ConnectedProps<typeof connector>) => {
    return !entitled ? (
        <div className={classnames('page-section', startTrialStyles.wrapper)}>
            <Grid container stackable>
                <Grid.Row verticalAlign="middle">
                    <Grid.Column width={12}>
                        <h1 className="accent">Go on demand</h1>
                        <h5 className="upper margin--0">
                            Access your workouts anytime, anywhere on iPhone, Android Phone, Android
                            Tablet and Web.
                        </h5>
                    </Grid.Column>
                    <Grid.Column textAlign="right" width={4}>
                        <Button
                            as={Link}
                            to="/checkout/?sku=1month_trial14&v=v1"
                            data-cta-name="freeTrial-bottom"
                        >
                            Start free trial
                        </Button>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    ) : null;
};

export default connector(StartTrial);
